/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Define_The_Core_Aesthetic_ElemInputs */

const en_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define the core aesthetic elements of your luxury store.`)
};

const es_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define los elementos estéticos centrales de tu tienda de lujo.`)
};

const fr_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définissez les éléments esthétiques centraux de votre boutique de luxe.`)
};

const de_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definiere die zentralen ästhetischen Elemente deines Luxus-Stores.`)
};

const ja_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラグジュアリーストアの中核となる美的要素を定義します。`)
};

const zh_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定义您奢华店铺的核心美学元素。`)
};

const ar_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد العناصر الجمالية الأساسية لمتجرك الفاخر.`)
};

const id_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentukan elemen estetika inti dari toko mewah Anda.`)
};

const it_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definisci gli elementi estetici centrali del tuo negozio di lusso.`)
};

const ru_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определите основные эстетические элементы вашего магазина премиум-класса.`)
};

const pt_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina os principais elementos estéticos da sua loja de luxo.`)
};

const ko_define_the_core_aesthetic_elem = /** @type {(inputs: Define_The_Core_Aesthetic_ElemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`럭셔리 스토어의 핵심적인 미적 요소를 정의하세요.`)
};

/**
* | output |
* | --- |
* | "Define the core aesthetic elements of your luxury store." |
*
* @param {Define_The_Core_Aesthetic_ElemInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const define_the_core_aesthetic_elem = /** @type {((inputs?: Define_The_Core_Aesthetic_ElemInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Define_The_Core_Aesthetic_ElemInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_define_the_core_aesthetic_elem(inputs)
	if (locale === "es") return es_define_the_core_aesthetic_elem(inputs)
	if (locale === "fr") return fr_define_the_core_aesthetic_elem(inputs)
	if (locale === "de") return de_define_the_core_aesthetic_elem(inputs)
	if (locale === "ja") return ja_define_the_core_aesthetic_elem(inputs)
	if (locale === "zh") return zh_define_the_core_aesthetic_elem(inputs)
	if (locale === "ar") return ar_define_the_core_aesthetic_elem(inputs)
	if (locale === "id") return id_define_the_core_aesthetic_elem(inputs)
	if (locale === "it") return it_define_the_core_aesthetic_elem(inputs)
	if (locale === "ru") return ru_define_the_core_aesthetic_elem(inputs)
	if (locale === "pt") return pt_define_the_core_aesthetic_elem(inputs)
	return ko_define_the_core_aesthetic_elem(inputs)
});